import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Clinic = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.295 2.876a2 2 0 0 0-2.59 0l-9.19 7.811a.75.75 0 0 0 .97 1.143l1.265-1.074v7.003A3.25 3.25 0 0 0 7 21.009h10a3.25 3.25 0 0 0 3.25-3.25v-7.003l1.264 1.074a.75.75 0 1 0 .972-1.143zM18.75 9.48l-6.426-5.463a.5.5 0 0 0-.648 0L5.25 9.481v8.278c0 .966.784 1.75 1.75 1.75h10a1.75 1.75 0 0 0 1.75-1.75z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.75 9.2a.5.5 0 0 0-.5.5v2.7H8.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h2.75v2.8a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-2.8h2.75a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-2.75V9.7a.5.5 0 0 0-.5-.5z'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.705 2.876a2 2 0 0 1 2.59 0l9.19 7.811a.75.75 0 0 1-.97 1.143l-1.265-1.074v7.003a3.25 3.25 0 0 1-3.25 3.25H7a3.25 3.25 0 0 1-3.25-3.25v-7.003L2.486 11.83a.75.75 0 1 1-.972-1.143zm.545 6.823a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v2.7h2.75a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-2.75v2.8a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-2.8H8.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h2.75z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
